module.exports = __webpack_public_path__ + "img/slider.0723a6b7.svg";